module.exports = __webpack_public_path__ + "static/rollover_health-b4f191cabb96c34cec63ac88a85e3184.svg";